import { render, staticRenderFns } from "./Carteraterapia.vue?vue&type=template&id=264469a9"
import script from "./Carteraterapia.vue?vue&type=script&lang=js"
export * from "./Carteraterapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports